import { Component, Inject, Optional } from '@angular/core';
import {
  DialogRef,
  DIALOG_DATA,
} from '@cyborg-monorepo/common/angular/cyborg-ui';

@Component({ standalone: false, 
  selector: 'api-key-dialog',
  templateUrl: './api-key-dialog.component.html',
  styleUrls: ['./api-key-dialog.component.scss'],
})
export class APIKeyDialogComponent {
  public copied: boolean = false;
  constructor(
    public dialogRef: DialogRef,
    @Optional()
    @Inject(DIALOG_DATA)
    public data: {
      apiKey: string;
      keyName: string;
    }
  ) {}

  public writeToClipboard(key: string): void {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 2000);
    navigator.clipboard.writeText(key);
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
